import { useTranslate } from '~/i18n';
import { AngelLeftIcon, AngelRightIcon } from '~/svgs/common';
import classNames from 'classnames';
import styles from './styles.module.css';
interface TitledPillProps {
   title: React.ReactNode;
   icon: any;
   description: React.ReactNode;
   titleClassname?: string;
   desClassname?: string;
}

const TitledPill = ({
   description,
   title,
   icon,
   titleClassname,
   desClassname,
}: TitledPillProps) => {
   const { dir } = useTranslate();
   return (
      <div
         className={classNames(
            'py-2 ltr:text-left rtl:text-right relative overflow-hidden',
            styles.pill
         )}>
         <div className={styles.bg}></div>
         <div className="flex items-center relative">
            <div
               className={classNames(
                  'ltr:mr-3 rtl:ml-3 inline-flex justify-center w-16 h-16 border rounded-3xl bg-white',
                  styles.icon
               )}>
               {icon}
            </div>
            <div>
               <div className="mb-1">
                  <span className={titleClassname ? titleClassname : 'font-bold flex items-center'}>
                     {title}
                     {dir === 'ltr' ? (
                        <AngelRightIcon className="w-4" />
                     ) : (
                        <AngelLeftIcon className="w-4" />
                     )}
                  </span>
               </div>
               <div className={desClassname ? desClassname : 'text-xs'}>{description}</div>
            </div>
         </div>
      </div>
   );
};

export default TitledPill;
